import _slicedToArray from "/home/ubuntu/onesaz/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { unpack } from '../../utils/index.js';
var cmyk2rgb = function cmyk2rgb() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  args = unpack(args, 'cmyk');
  var _args = args,
    _args2 = _slicedToArray(_args, 4),
    c = _args2[0],
    m = _args2[1],
    y = _args2[2],
    k = _args2[3];
  var alpha = args.length > 4 ? args[4] : 1;
  if (k === 1) return [0, 0, 0, alpha];
  return [c >= 1 ? 0 : 255 * (1 - c) * (1 - k),
  // r
  m >= 1 ? 0 : 255 * (1 - m) * (1 - k),
  // g
  y >= 1 ? 0 : 255 * (1 - y) * (1 - k),
  // b
  alpha];
};
export default cmyk2rgb;